export default "__VITE_ASSET__DFvm$_KC__"